import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { RestApiProvider } from '../../providers/rest-api/rest-api';
import { AddcouponPage } from '../addcoupon/addcoupon';
import { EditcouponPage } from '../editcoupon/editcoupon';
import { RicercacouponPage } from '../ricercacoupon/ricercacoupon';

/**
 * Generated class for the CouponPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-coupon',
  templateUrl: 'coupon.html',
})
export class CouponPage {
  coupons;
  errorMessage;
  constructor(public navCtrl: NavController,
    public rest: RestApiProvider,

    public navParams: NavParams) {
     // alert("a")
  }

  ionViewDidLoad() {

    console.log('ionViewDidLoad MarcaPage');
    this.getCoupons();
  }
  openRicercaCouponPage(){
    this.navCtrl.push(RicercacouponPage);

  }
  getCoupons() {
    this.rest.getCoupons()
      .subscribe(
        coupons => this.coupons = coupons,
        error => this.errorMessage = <any>error);
  }
  openAddCouponPage() {

    this.navCtrl.push(AddcouponPage);


  }
  openEditCouponPage(coupon){
  //  alert(JSON.stringify(coupon))
    this.navCtrl.push(EditcouponPage,{coupon:coupon});

  }
}



// WEBPACK FOOTER //
// ./src/pages/coupon/coupon.ts